<mat-sidenav-container fullscreen>
    <mat-sidenav #sidenav mode="side" [ngClass]="classState" [ngStyle]="{ 'width.px': sidenavWidth }" opened="true"
        [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : 'side'"
        [opened]="(isHandset$ | async) === false">

        <div class="logosymbol"><img src="assets/images/logo-symbol.svg" alt="Logo Symbol"></div>
        <div class="logofull"><img src="assets/images/logo-full.svg" alt="Logo Full"></div>

        <mat-nav-list *ngIf="activeDashboard===Roles.cprUser">
            <mat-list-item routerLinkActive="active" class="icon-collapse-wrap">
                <mat-icon *ngIf="sidenavWidth < 61" mat-list-icon (click)="increase()">keyboard_arrow_right</mat-icon>
                <mat-icon *ngIf="sidenavWidth > 61" mat-list-icon (click)="decrease()">keyboard_arrow_left</mat-icon>

            </mat-list-item>

            <mat-list-item routerLink="/app/dashboard/" routerLinkActive="active"
                [matTooltip]="classState == 'sidebar-collapsed' ? ('Dashboard' | translate) : ''"
                [matTooltipClass]="classState == 'sidebar-collapsed' ? 'tooltip' : ''">
                <span class="icon-dashboard icon-active">
                    <img src="assets/images/icons/icon-cp-dashboard-active.svg" alt="Dashboard Active"> </span>
                <span class="icon-dashboard icon-inactive">
                    <img src="assets/images/icons/icon-cp-dashboard-inactive.svg" alt="Dashboard Inactive"> </span>
                <div fxFlex="10"></div>
                <div *ngIf="sidenavWidth > 61" class="sidenav-item">
                    <h5 class="nav-text">{{'Dashboard' | translate}}</h5>
                </div>
            </mat-list-item>

            <mat-list-item routerLink="/app/organization/" routerLinkActive="active"
                [matTooltip]="classState == 'sidebar-collapsed' ? ('Organizations' | translate) : ''"
                [matTooltipClass]="classState == 'sidebar-collapsed' ? 'tooltip' : ''">
                <span class="icon-audience icon-active"> <img src="assets/images/icons/icon-cp-organizations-active.svg"
                        alt="Audience Active"> </span>
                <span class="icon-audience icon-inactive"> <img
                        src="assets/images/icons/icon-cp-organizations-inactive.svg" alt="Audience Inactive"> </span>
                <div fxFlex="10"></div>
                <div *ngIf="sidenavWidth > 61" class="sidenav-item">
                    <h5 class="nav-text">{{'Organizations' | translate}}</h5>
                </div>
            </mat-list-item>

            <mat-list-item routerLink="/app/employees/" routerLinkActive="active"
                [matTooltip]="classState == 'sidebar-collapsed' ? ('Employees' | translate) : ''"
                [matTooltipClass]="classState == 'sidebar-collapsed' ? 'tooltip' : ''">
                <span class="icon-engagement icon-active"> <img src="assets/images/icons/icon-cp-employees-active.svg"
                        alt="Engagement Active"> </span>
                <span class="icon-engagement icon-inactive"> <img
                        src="assets/images/icons/icon-cp-employees-inactive.svg" alt="Engagement Inactive"> </span>
                <div fxFlex="10"></div>
                <div *ngIf="sidenavWidth > 61" class="sidenav-item">
                    <h5 class="nav-text">{{'Employees'|translate}}</h5>
                </div>
            </mat-list-item>

            <mat-list-item routerLink="/app/individuals/" routerLinkActive="active"
                [matTooltip]="classState == 'sidebar-collapsed' ? ('Individuals' | translate) : ''"
                [matTooltipClass]="classState == 'sidebar-collapsed' ? 'tooltip' : ''">
                <span class="icon-scheduled icon-active"> <img src="assets/images/icons/icon-cp-individuals-active.svg"
                        alt="Scheduled Active"> </span>
                <span class="icon-scheduled icon-inactive"> <img
                        src="assets/images/icons/icon-cp-individuals-inactive.svg" alt="Scheduled Inactive"> </span>
                <div fxFlex="10"></div>
                <div *ngIf="sidenavWidth > 61" class="sidenav-item">
                    <h5 class="nav-text">{{'Individuals'|translate}}</h5>
                </div>
            </mat-list-item>
        </mat-nav-list>

        <mat-nav-list *ngIf="activeDashboard===Roles.mktUser ">
            <mat-list-item routerLinkActive="active" class="icon-collapse-wrap">
                <mat-icon *ngIf="sidenavWidth < 61" mat-list-icon (click)="increase()">keyboard_arrow_right</mat-icon>
                <mat-icon *ngIf="sidenavWidth > 61" mat-list-icon (click)="decrease()">keyboard_arrow_left</mat-icon>
            </mat-list-item>

            <mat-list-item routerLink="/app/dashboard/mkt" routerLinkActive="active"
                [matTooltip]="classState == 'sidebar-collapsed' ? ('Dashboard' | translate) : ''"
                [matTooltipClass]="classState == 'sidebar-collapsed' ? 'tooltip' : ''">
                <span class="icon-dashboard icon-active"> <img src="assets/images/icons/icon-cp-dashboard-active.svg"
                        alt="Dashboard Active"> </span>
                <span class="icon-dashboard icon-inactive"> <img
                        src="assets/images/icons/icon-cp-dashboard-inactive.svg" alt="Dashboard Inactive"> </span>
                <div fxFlex="10"></div>
                <div *ngIf="sidenavWidth > 61" class="sidenav-item">
                    <h5 class="nav-text">{{'Dashboard'|translate}}</h5>
                </div>
            </mat-list-item>

            <mat-list-item routerLink="/app/journeys/" routerLinkActive="active"
                [matTooltip]="classState == 'sidebar-collapsed' ? ('Journeys' | translate) : ''"
                [matTooltipClass]="classState == 'sidebar-collapsed' ? 'tooltip' : ''">
                <span class="icon-audience icon-active"> <img src="assets/images/icons/icon-mk-journey-active.svg"
                        alt="Journey Active"> </span>
                <span class="icon-audience icon-inactive"> <img src="assets/images/icons/icon-mk-journey-inactive.svg"
                        alt="Journey Inactive"> </span>
                <div fxFlex="10"></div>
                <div *ngIf="sidenavWidth > 61" class="sidenav-item">
                    <h5 class="nav-text">{{'Journeys'|translate}}</h5>
                </div>
            </mat-list-item>

            <mat-list-item routerLink="/app/emails/" routerLinkActive="active"
                [matTooltip]="classState == 'sidebar-collapsed' ? ('Emails' | translate) : ''"
                [matTooltipClass]="classState == 'sidebar-collapsed' ? 'tooltip' : ''">
                <span class="icon-engagement icon-active"> <img src="assets/images/icons/icon-mk-email-active.svg"
                        alt="Email Active"> </span>
                <span class="icon-engagement icon-inactive"> <img src="assets/images/icons/icon-mk-email-inactive.svg"
                        alt="Email Inactive"> </span>
                <div fxFlex="10"></div>
                <div *ngIf="sidenavWidth > 61" class="sidenav-item">
                    <h5 class="nav-text">{{'Emails'|translate}}</h5>
                </div>
            </mat-list-item>

            <mat-list-item routerLink="/app/texts/" routerLinkActive="active"
                [matTooltip]="classState == 'sidebar-collapsed' ? ('SMS' | translate) : ''"
                [matTooltipClass]="classState == 'sidebar-collapsed' ? 'tooltip' : ''">
                <span class="icon-scheduled icon-active"> <img src="assets/images/icons/icon-mk-texts-active.svg"
                        alt="Texts Active"> </span>
                <span class="icon-scheduled icon-inactive"> <img src="assets/images/icons/icon-mk-texts-inactive.svg"
                        alt="Texts Inactive"> </span>
                <div fxFlex="10"></div>
                <div *ngIf="sidenavWidth > 61" class="sidenav-item">
                    <h5 class="nav-text">{{'SMS'|translate}}</h5>
                </div>
            </mat-list-item>

            <mat-list-item routerLink="/app/segments/" routerLinkActive="active"
                [matTooltip]="classState == 'sidebar-collapsed' ? ('Segments' | translate) : ''"
                [matTooltipClass]="classState == 'sidebar-collapsed' ? 'tooltip' : ''">
                <span class="icon-scheduled icon-active"> <img src="assets/images/icons/icon-mk-charts-active.svg"
                        alt="Segments Active"> </span>
                <span class="icon-scheduled icon-inactive"> <img src="assets/images/icons/icon-mk-charts-inactive.svg"
                        alt="Segments Inactive"> </span>
                <div fxFlex="10"></div>
                <div *ngIf="sidenavWidth > 61" class="sidenav-item">
                    <h5 class="nav-text">{{'Segments'|translate}}</h5>
                </div>
            </mat-list-item>

            <mat-list-item routerLink="/app/tasks/" routerLinkActive="active"
                [matTooltip]="classState == 'sidebar-collapsed' ? ('Tasks' | translate) : ''"
                [matTooltipClass]="classState == 'sidebar-collapsed' ? 'tooltip' : ''">
                <span class="icon-scheduled icon-active"> <img src="assets/images/icons/icon-mk-tasks-active.svg"
                        alt="Tasks Active" style="margin: 0 0 0 -4px;"> </span>
                <span class="icon-scheduled icon-inactive"> <img src="assets/images/icons/icon-mk-tasks-inactive.svg"
                        alt="Tasks Inactive" style="margin: 0 0 0 -4px;"> </span>
                <div fxFlex="10"></div>
                <div *ngIf="sidenavWidth > 61" class="sidenav-item">
                    <h5 class="nav-text">{{'Tasks'|translate}}</h5>
                </div>
            </mat-list-item>

            <mat-list-item routerLink="/app/broadcast/" routerLinkActive="active"
                [matTooltip]="classState == 'sidebar-collapsed' ? ('BotCast' | translate) : ''"
                [matTooltipClass]="classState == 'sidebar-collapsed' ? 'tooltip' : ''">
                <span class="icon-scheduled icon-active"> <img src="assets/images/icons/icon-mk-botcast-active.svg"
                        alt="Tasks Active"> </span>
                <span class="icon-scheduled icon-inactive"> <img src="assets/images/icons/icon-mk-botcast-inactive.svg"
                        alt="Tasks Inactive"> </span>
                <div fxFlex="10"></div>
                <div *ngIf="sidenavWidth > 61" class="sidenav-item">
                    <h5 class="nav-text">{{'BotCast'|translate}}</h5>
                </div>
            </mat-list-item>
            <mat-list-item routerLink="marketing/activities" routerLinkActive="active"
            [matTooltip]="classState == 'sidebar-collapsed' ? ('Marketing Activities' | translate) : ''"
            [matTooltipClass]="classState == 'sidebar-collapsed' ? 'tooltip' : ''">
            <span class="icon-scheduled icon-active"> <img src="assets/images/icons/marketing-activities-active.svg"
                    alt="Tasks Active"> </span>
            <span class="icon-scheduled icon-inactive"> <img src="assets/images/icons/marketing-activities-inactive.svg"
                    alt="Tasks Inactive"> </span>
            <div fxFlex="10"></div>
            <div *ngIf="sidenavWidth > 61" class="sidenav-item">
                <h5 class="nav-text">{{'Marketing Activities'|translate}}</h5>
            </div>
        </mat-list-item>
        </mat-nav-list>

        <mat-nav-list *ngIf="activeDashboard===Roles.cmUser">
            <mat-list-item routerLinkActive="active" class="icon-collapse-wrap">
                <mat-icon *ngIf="sidenavWidth < 61" mat-list-icon (click)="increase()">keyboard_arrow_right</mat-icon>
                <mat-icon *ngIf="sidenavWidth > 61" mat-list-icon (click)="decrease()">keyboard_arrow_left</mat-icon>
            </mat-list-item>

            <mat-list-item routerLink="/app/dashboard/cm" routerLinkActive="active"
                [matTooltip]="classState == 'sidebar-collapsed' ? ('Dashboard' | translate) : ''"
                [matTooltipClass]="classState == 'sidebar-collapsed' ? 'tooltip' : ''">
                <span class="icon-dashboard icon-active">
                    <img src="assets/images/icons/icon-cp-dashboard-active.svg" alt="Dashboard Active"> </span>
                <span class="icon-dashboard icon-inactive">
                    <img src="assets/images/icons/icon-cp-dashboard-inactive.svg" alt="Dashboard Inactive"> </span>
                <div fxFlex="10"></div>
                <div *ngIf="sidenavWidth > 61" class="sidenav-item">
                    <h5 class="nav-text">{{'Dashboard' | translate}}</h5>
                </div>
            </mat-list-item>

            <!-- <mat-list-item routerLink="/app/cases/" routerLinkActive="active"
                [matTooltip]="classState == 'sidebar-collapsed' ? ('Cases' | translate) : ''"
                [matTooltipClass]="classState == 'sidebar-collapsed' ? 'tooltip' : ''">
                <span class="icon-audience icon-active"> <img src="assets/images/icons/icon-mk-charts-active.svg"
                        alt="Audience Active"> </span>
                <span class="icon-audience icon-inactive"> <img
                        src="assets/images/icons/icon-mk-charts-inactive.svg" alt="Audience Inactive"> </span>
                <div fxFlex="10"></div>
                <div *ngIf="sidenavWidth > 61" class="sidenav-item">
                    <h5 class="nav-text">{{'Cases' | translate}}</h5>
                </div>
            </mat-list-item> -->
        </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
        <div style="height: 100vh;">
            <mat-toolbar class="ad-topbar">
                <div class="container-fluid">
                    <div class="row justify-content-between">
                        <div class="col-4 topbar-left">
                            <mat-form-field>
                                <mat-select [(value)]="dashboardType" (selectionChange)="dashboardChange($event.value)">
                                    <mat-option [value]="Roles.cprUser"
                                        *ngIf="userRoles === Roles.adminUser || userRoles === Roles.cprUser ">
                                        {{'Customer Profiling'|translate}}</mat-option>
                                    <mat-option [value]="Roles.mktUser"
                                        *ngIf="userRoles === Roles.adminUser || userRoles === Roles.mktUser ">{{'Marketing'|translate}}</mat-option>
                                    <mat-option [value]="Roles.eService">{{'Case Management'|translate}}</mat-option>
                                    <!-- <mat-option [value]="Roles.cmUser" *ngIf="userRoles === Roles.adminUser">
                                        {{'Case Management'|translate}}</mat-option> -->
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-7 topbar-right align-self-center text-end justify-content-end">
                            <div class="search-wrap align-self-center">
                                <input type="text" class="search-field"
                                    [placeholder]="'Search for data, users...'|translate" [(ngModel)]="searchKeyWord"
                                    (keyup.enter)="globalSearch(searchKeyWord)">
                            </div>
                            <div class="lang-select">
                                <mat-form-field>
                                    <mat-select value="transService?.slectedlang" [(value)]="selectedLang"
                                        (selectionChange)="lan($event.value)">
                                        <mat-option value="en">EN</mat-option>
                                        <mat-option value="ar">عربی</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="profile-wrap align-self-center" *ngIf="selectedLang === 'en'">
                                <a>
                                    <span class="name"> {{this.commonService.getShortName(loggedInUser?.name)}} </span>
                                </a>
                            </div>
                            <div class="user-wrap align-self-center">
                                <button mat-button [matMenuTriggerFor]="menu"><span class="username">{{ selectedLang
                                        ==='en'?loggedInUser?.name:loggedInUser?.arabicName }}</span>
                                    <!-- <small class="userrole">{{'Sub Admin'|translate}}</small> -->
                                    <span class="icon-down-arrow"></span>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="logout()">{{'Logout'|translate}}</button>
                                </mat-menu>
                            </div>

                        </div>
                    </div>
                </div>
            </mat-toolbar>
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>

</mat-sidenav-container>